<template>
  <div>
    <div class="page page__list">
      <search-bar
        @search="onSearch"
        name="qs_code,pr_code,pr_detail,pr_orispeccode,pr_spec"
        placeholder="输入物料编号、名称、规格或者型号进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.qs_id"
          :to="'/quality/iqcset/' + item.qs_id"
        >
          <div class="weui-cell__bd">
            <p>{{ item.qs_code }}</p>
            <p class="list-item-muted">{{ item.pr_code }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.pr_detail }}</p>
            <span
              class="list-item-status"
              :class="{ warning: item.qs_status != '已审核' }"
              >{{ item.qs_status }}</span
            >
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ items.length }}笔</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/storage/qcset/list",
      filters: [
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              condition: "qs_qcclass=\"IQC\""
            }
          ],
        },
      ],
    };
  }
};
</script>